<p-card class="xl-radius">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-2">
                <img class="icon-smaller" src="icons/usage-icon.png" />
            </div>
            <div class="col-10">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Verbruik</h5>
            </div>
        </div>
    </ng-template>
    <consumption-graph-component></consumption-graph-component>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-8 pt-4">
            </div>
            <div class="col-4 pt-4">
                <p-button [styleClass]="'float-right'" [outlined]="true" (click)="activeTab = 'usage'; activeTabChange.emit(activeTab)">Details bekijken</p-button>
            </div>
        </div>
    </ng-template>
</p-card>